import { ThemeMode } from './types/themeStoreTypes'

export const getSystemColorScheme = (): ThemeMode => {
  if (typeof window === 'undefined') return 'dark'
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}
